// import PropTypes from 'prop-types'
import { Box, ButtonBase, alpha } from "@mui/material";
import { Link } from "react-router-dom";
import { flame } from "@/theme/colors";

export const SideNavItem = (props) => {
  const { active = false, disabled, external, icon, path, title } = props;
  const isContacts = title === "Contacts";
  const shouldBeWhite = ["Activities", "Forms", "Submitted Forms", "Users", "Documents", "Companies"].includes(title);

  const linkProps = path
    ? external
      ? {
        component: "a",
        href: path,
        target: "_blank",
      }
      : {
        component: Link,
        to: path,
      }
    : {};

  return (
    <li>
      <ButtonBase
        sx={{
          alignItems: "center",
          borderRadius: 1,
          display: "flex",
          justifyContent: "flex-start",
          pl: "16px",
          pr: "16px",
          py: "6px",
          textAlign: "left",
          width: "100%",
          ...(active && {
            backgroundColor: flame[500],
          }),
          "&:hover": {
            backgroundColor: alpha(flame[500], 0.04),
          },
        }}
        {...linkProps}
      >
        {icon && (
          <Box
            component="span"
            sx={{
              alignItems: "center",
              color: shouldBeWhite ? "common.white" : "neutral.400",
              display: "inline-flex",
              justifyContent: "center",
              mr: 2,
              ...(shouldBeWhite && {
                "& img": {
                  filter: "brightness(0) invert(1)",
                },
              }),
              ...(active && !shouldBeWhite && {
                color: "primary.main",
              }),
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          component="span"
          sx={{
            color: "neutral.400",
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 14,
            fontWeight: 600,
            lineHeight: "24px",
            whiteSpace: "nowrap",
            ...(active && {
              color: "common.white",
            }),
            ...(disabled && {
              color: "neutral.500",
            }),
          }}
        >
          {title}
        </Box>
      </ButtonBase>
    </li>
  );
};
